/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DataTable from '../../../core/DataTable';

import { genDataColumns, genDataRows, dataFiller } from '../../utils/formatCharts/handleData';

const customRowSort = (rows, config) => {
  if (config && rows) {
    const copyData = [...rows];
    const { kpiCategories } = config.CustomSortControl;
    return copyData.sort((a, b) => kpiCategories.indexOf(a.index) - kpiCategories.indexOf(b.index));
  }
  return rows;
};

const emptyObj = {};

const DataFrameTable = ({
  data = emptyObj,
  styleConfig = emptyObj,
  isEdit = true,
  valueFunction = 'sum',
  globalConfig = emptyObj,
}) => {
  const [tableCols, setTableCols] = useState({ ready: false });
  const [tableRows, setTableRows] = useState({ ready: false });

  useEffect(() => {
    const isAvg = styleConfig?.TotalFunctionControl ? styleConfig.TotalFunctionControl === 'avg' : valueFunction === 'mean';
    setTableCols(genDataColumns(dataFiller(data, styleConfig), styleConfig, !isEdit, isAvg));
  }, [data, isEdit,
    styleConfig.CustomSortColumnControl.kpiCategories,
    styleConfig.SortColumnsControl,
    styleConfig.ColumnShowTotalControl,
    styleConfig.ColumnOnlyShowTotalControl,
    styleConfig.LabelCurrencyControl,
    styleConfig.Decimals,
    styleConfig.separadorNumericoCasas,
    styleConfig.LabelGroupingControl,
    styleConfig.PrefixControl,
    styleConfig.SufixControl,
    valueFunction,
    styleConfig?.TotalFunctionControl,
    styleConfig?.DataFormat,
    styleConfig?.DataPercentFormat,
    styleConfig?.DataAbsoluteFormat,
    styleConfig?.DataFormatAlt,
    styleConfig?.DataPercentFormatAlt,
    styleConfig?.DataAbsoluteFormatAlt,
    styleConfig?.DurationUnit,
    styleConfig.ExtendDateColumn,
    styleConfig.ExtendDateLine,
    styleConfig?.MinValueControl?.checked,
    styleConfig?.MinValueControl?.value,
    styleConfig?.MaxValueControl?.checked,
    styleConfig?.MaxValueControl?.value,
  ]);

  useEffect(() => {
    setTableRows(genDataRows(dataFiller(data, styleConfig), false, styleConfig));
  }, [
    data,
    styleConfig?.DataFormat,
    styleConfig?.DataPercentFormat,
    styleConfig?.DataAbsoluteFormat,
    styleConfig?.DataFormatAlt,
    styleConfig?.DataPercentFormatAlt,
    styleConfig?.DataAbsoluteFormatAlt,
    styleConfig.ExtendDateColumn,
    styleConfig.ExtendDateLine,
    styleConfig?.MinValueControl?.checked,
    styleConfig?.MinValueControl?.value,
    styleConfig?.MaxValueControl?.checked,
    styleConfig?.MaxValueControl?.value,
  ]);

  useEffect(() => {
    if (tableRows.ready
      && styleConfig.CustomSortControl?.checked && styleConfig.CustomSortControl.kpiCategories) {
      setTableRows((cRows) => ({
        ...cRows,
        rows: customRowSort(tableRows.rows, styleConfig),
      }));
    }
  }, [
    ...styleConfig.CustomSortControl.kpiCategories,
    styleConfig.SortValuesControl,
    tableRows.ready,
  ]);

  const getSortField = () => {
    if (styleConfig.SortValuesControl === 'Customizado') return '';
    if (styleConfig.SortValuesControl === 'Não ordenado') return 'index';
    return styleConfig.ColumnToSortControl || 'index';
  };

  return tableCols.ready && tableRows.ready ? (
    <div
      style={{
        padding: '0 5px',
        position: 'relative',
        overflowY: 'auto',
        height: '100%',
      }}
      className="tableWrapper"
    >
      <DataTable
        columns={tableCols.cols || []}
        rowData={
          Array.isArray(tableRows.rows) && !styleConfig.LineOnlyShowTotalControl
            ? tableRows.rows : []
        }
        rowTotals={styleConfig.LineShowTotalControl ? tableRows.rowTotals : undefined}
        tableStyle={{
          ...styleConfig,
          LabelsFontFamilyControl: globalConfig?.useGlobalFont ? {
            value: globalConfig.fontTable,
          } : styleConfig.LabelsFontFamilyControl,
        }}
        defaultSortField={getSortField()}
        defaultSortOrder={styleConfig.SortValuesControl === 'Decrescente' ? 'descending' : 'ascending'}
        compact
        headerColor={globalConfig?.useGlobalTheme ? globalConfig.tableHeader : styleConfig.HeaderColor ?? 'white'}
        rowColor={globalConfig?.useGlobalTheme ? globalConfig.tableRows[0] : styleConfig.RowColor ?? 'white'}
        strippedRowsColor={globalConfig?.useGlobalTheme ? globalConfig.tableRows[1] : (
          styleConfig.LineColorControl === 'striped' ? (
            styleConfig.StripedRowsColor || 'white'
          ) : (
            styleConfig.RowColor || 'white'
          )
        )}
        useNumSorting
      />
    </div>
  ) : <></>;
};

DataFrameTable.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  styleConfig: PropTypes.objectOf(PropTypes.any),
  isEdit: PropTypes.bool,
  valueFunction: PropTypes.string,
  globalConfig: PropTypes.objectOf(PropTypes.any),
};

export default DataFrameTable;
